export default "__VITE_ASSET__DDye2NL9__"